import { render, staticRenderFns } from "./Pl3Set.vue?vue&type=template&id=4ce7c6a4&scoped=true&"
import script from "./Pl3Set.vue?vue&type=script&lang=js&"
export * from "./Pl3Set.vue?vue&type=script&lang=js&"
import style0 from "./Pl3Set.vue?vue&type=style&index=0&id=4ce7c6a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce7c6a4",
  null
  
)

export default component.exports